"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardAnimation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const native_1 = require("@react-navigation/native");
const react_redux_1 = require("react-redux");
const react_native_reanimated_1 = __importStar(require("react-native-reanimated"));
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const react_native_keyboard_controller_1 = require("react-native-keyboard-controller");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const lottie_react_native_1 = __importDefault(require("lottie-react-native"));
const react_speech_recognition_1 = require("react-speech-recognition");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const rootNavigation_1 = require("../../navigation/rootNavigation");
const user_1 = require("../../store/selectors/user");
const document_1 = require("../../store/selectors/document");
const user_2 = require("../../slices/user");
const document_2 = require("../../slices/document");
const useDevice_1 = require("../../hooks/useDevice");
const useRequest_1 = __importDefault(require("../../hooks/useRequest"));
const useChatMessages_1 = require("../../hooks/useChatMessages");
const useConversations_1 = require("../../hooks/useConversations");
const useGptJourneyImage_1 = require("../../hooks/useGptJourneyImage");
const useDocument_1 = __importDefault(require("../../hooks/useDocument"));
const VStack_1 = __importDefault(require("../../component/ui-components/VStack"));
const ScrollCustomIndicator_1 = __importDefault(require("../../component/ScrollCustomIndicator"));
const DocumentHeaderItem_1 = __importDefault(require("../../component/DocumentHeader/DocumentHeaderItem"));
const AppQuotaAlert_1 = __importDefault(require("../../component/AppQuotaAlert"));
const ChatThreadsHeaderButton_1 = __importDefault(require("../../component/Conversations/ChatThreadsHeaderButton"));
const UploadedSources_1 = __importDefault(require("../../component/Chat/UploadedSources"));
const UploadMenu_1 = __importDefault(require("../../component/Chat/UploadMenu"));
const MicrophoneButton_1 = require("../../component/GradientButton/MicrophoneButton");
const SendButton_1 = require("../../component/GradientButton/SendButton");
const MesssageBoxInput_1 = __importDefault(require("../../component/AppInput/MesssageBoxInput"));
const UpgradeBanner_1 = __importDefault(require("../../component/UpgradeBanner"));
const AppLoader_1 = __importDefault(require("../../component/AppLoader"));
const AppBackground_1 = __importDefault(require("../../component/AppBackground"));
const AppButton_1 = require("../../component/AppButton");
const AppText_1 = require("../../component/AppText");
const ChatMessages_1 = __importDefault(require("./ChatMessages"));
const document_3 = require("../../services/document");
const theme_1 = require("../../helper/theme");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const DEFAULT_RIPPLE_SIZE = 100;
const AnimatedContainer = react_native_reanimated_1.default.createAnimatedComponent(VStack_1.default);
const MESSAGE_BUTTON_WIDTH = 30;
const useKeyboardAnimation = () => {
    if (react_native_1.Platform.OS === "web") {
        return {
            height: {
                value: 100,
            },
            progress: 0,
        };
    }
    const progress = (0, react_native_reanimated_1.useSharedValue)(0);
    const height = (0, react_native_reanimated_1.useSharedValue)(0);
    const shouldUseOnMoveHandler = (0, react_native_reanimated_1.useSharedValue)(false);
    (0, react_native_keyboard_controller_1.useKeyboardHandler)({
        onStart: (e) => {
            "worklet";
            // i. e. the keyboard was under interactive gesture, and will be showed
            // again. Since iOS will not schedule layout animation for that we can't
            // simply update `height` to destination and we need to listen to `onMove`
            // handler to have a smooth animation
            if (progress.value !== 1 && progress.value !== 0 && e.height !== 0) {
                shouldUseOnMoveHandler.value = true;
                return;
            }
            progress.value = e.progress;
            height.value = e.height;
        },
        onInteractive: (e) => {
            "worklet";
            progress.value = e.progress;
            height.value = e.height;
        },
        onMove: (e) => {
            "worklet";
            if (shouldUseOnMoveHandler.value) {
                progress.value = e.progress;
                height.value = e.height;
            }
        },
        onEnd: (e) => {
            "worklet";
            height.value = e.height;
            progress.value = e.progress;
            shouldUseOnMoveHandler.value = false;
        },
    });
    return { height, progress };
};
exports.useKeyboardAnimation = useKeyboardAnimation;
const OneToOneChat = (props) => {
    const { isTabOrDesktopDevice, isDesktopDevice, isWebDevice, isMobileScreen, isPortrait, deviceWidth, deviceHeight, } = (0, useDevice_1.useDevice)();
    const isFocused = (0, native_1.useIsFocused)();
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { request } = (0, useRequest_1.default)();
    const { height } = (0, exports.useKeyboardAnimation)();
    const { handleCreateInitialConversation, pickConversation } = (0, useConversations_1.useConversations)();
    const { sendMessageAsStream, refreshMessageQuota } = (0, useChatMessages_1.useChatMessages)();
    const { generateJourneyImages } = (0, useGptJourneyImage_1.useGptJourneyImage)();
    const { browserSupportsSpeechRecognition } = (0, react_speech_recognition_1.useSpeechRecognition)();
    const { showShareLink, startDocumentConversation } = (0, useDocument_1.default)();
    const user = (0, react_redux_1.useSelector)(user_1.selectUser);
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const characterProfile = (0, react_redux_1.useSelector)((state) => state.getUserOptions.characterProfile);
    const conversation = (0, react_redux_1.useSelector)((state) => state.getUserOptions.conversation);
    const storedMessages = (0, react_redux_1.useSelector)((state) => state.getUserOptions.storedMessages);
    const documentJson = (0, react_redux_1.useSelector)(document_1.selectDocumentJson);
    const selectedFileIds = (0, react_redux_1.useSelector)(document_1.selectSelectedFileIds);
    const documentSummary = (0, react_redux_1.useSelector)(document_1.selectDocumentSummary);
    const textStreaming = (0, react_redux_1.useSelector)((state) => state.getUserOptions.textStreaming);
    const characterIsTyping = (0, react_redux_1.useSelector)((state) => state.getUserOptions.IsCharacterTyping);
    const messageQuota = (0, react_redux_1.useSelector)((state) => state.subscriptionPlan?.quota?.conversations);
    const isImageLoading = (0, react_redux_1.useSelector)((state) => state.getUserOptions.isImageLoading);
    const isMsgBox = (0, react_redux_1.useSelector)((state) => state.getSearchInputFlag.isMsgBox);
    const characterImagesEnabled = (0, react_redux_1.useSelector)((state) => state.getUserOptions.characterImagesEnabled);
    const voiceAutoPlay = (0, react_redux_1.useSelector)((state) => state.getUserOptions.voiceAutoPlay);
    const boxHeight = (0, react_native_reanimated_1.useSharedValue)(0);
    const [oldCharacterId, setOldCharacterId] = (0, react_1.useState)();
    const [uploadedSources, setUploadedSources] = (0, react_1.useState)([]);
    const [newMessege, setNewMessege] = (0, react_1.useState)("");
    // Typing modes:-
    // '': No mode, activate speech button.
    // 'voice': user selected voice mode manually.
    // 'text': User turned voice control off or starts typing.
    const [typingMode, setTypingMode] = (0, react_1.useState)("");
    const [pitch, setPitch] = (0, react_1.useState)(0.1);
    const [sourcesHeight, setSourcesHeight] = (0, react_1.useState)(0);
    const [forceVoiceStop, setForceVoiceStop] = (0, react_1.useState)(false);
    const [isRecording, setIsRecording] = (0, react_1.useState)(false);
    const [keyboardStatus, setKeyboardStatus] = (0, react_1.useState)("Keyboard_Hidden");
    const [autoFocus, setAutoFocus] = (0, react_1.useState)(false);
    const timerRef = (0, react_1.useRef)();
    let inputEl = (0, react_1.useRef)();
    const wasDocumentClearedControl = (0, react_1.useRef)(false);
    const wasDocumentFetchedControl = (0, react_1.useRef)(false);
    const wasConversationStarted = (0, react_1.useRef)(false);
    const mainWidth = (0, react_1.useMemo)(() => ((deviceWidth - constants_1.DISCOVER_SIDE_TAB_WIDTH) * 68) / 100, []);
    const X_INSETS = (0, react_1.useMemo)(() => {
        return insets.left + insets.right || 20;
    }, [insets]);
    const navigation = (0, react_1.useMemo)(() => (Object.hasOwn(props, 'navigation')
        ? props.navigation
        : undefined), [props]);
    const route = (0, react_1.useMemo)(() => (Object.hasOwn(props, 'route')
        ? props.route
        : undefined), [props]);
    const characterId = (0, react_1.useMemo)(() => (Object.hasOwn(props, 'characterId')
        ? props.characterId
        : props.route.params.characterId), [props]);
    const isTutorMode = (0, react_1.useMemo)(() => (Object.hasOwn(props, 'characterId')
        ? props.tutorMode
        : props.route.params.tutorMode), [props]);
    const paramConversationId = (0, react_1.useMemo)(() => (route?.params?.conversationId), [props]);
    const paramShareId = (0, react_1.useMemo)(() => (route?.params?.shareId), [props]);
    const autoMessage = (0, react_1.useMemo)(() => (Object.hasOwn(route?.params ?? {}, 'autoMessage')
        ? route.params.autoMessage
        : undefined), [route]);
    const password = (0, react_1.useMemo)(() => (Object.hasOwn(route?.params ?? {}, 'password')
        ? route.params.password
        : undefined), [route]);
    const isUserLogged = (0, react_1.useMemo)(() => (Boolean(fbUser)), [fbUser]);
    const wasCharacterLoaded = (0, react_1.useMemo)(() => Boolean(characterProfile.id), [characterProfile]);
    const wasReachedMessagesLimit = (0, react_1.useMemo)(() => (messageQuota.consumed >= messageQuota.quota), [messageQuota]);
    const isSendDisabled = (0, react_1.useMemo)(() => {
        return ((messageQuota &&
            messageQuota?.consumed ===
                messageQuota?.quota &&
            messageQuota?.quota !== 0) ||
            characterIsTyping ||
            isImageLoading);
    }, [messageQuota, isImageLoading, newMessege, characterIsTyping]);
    const rippleSize = (0, react_1.useMemo)(() => {
        const rippleDyaSize = DEFAULT_RIPPLE_SIZE * pitch;
        return rippleDyaSize > 200 ? 200 : rippleDyaSize;
    }, [pitch]);
    const wasUploadedImage = (0, react_1.useMemo)(() => (uploadedSources.some((source) => source.type === 'image')), [uploadedSources]);
    const wasUploadedFile = (0, react_1.useMemo)(() => (uploadedSources.some((source) => source.type === 'file')), [uploadedSources]);
    const boxAnimation = (0, react_native_reanimated_1.useAnimatedStyle)(() => {
        return {
            height: (0, react_native_reanimated_1.withTiming)(boxHeight.value || 320, { duration: 500 }),
        };
    }, [height]);
    const containerStyle = (0, react_native_reanimated_1.useAnimatedStyle)(() => ({
        transform: [{
                translateY: react_native_1.Platform.OS === 'web' ? 0 : -height.value,
            }],
        // for tabs we have 32% - 68%
        width: isTabOrDesktopDevice ? react_native_1.Platform.OS === 'web' ? '100%' : mainWidth : "100%",
        // position: "absolute",
        bottom: 0,
        paddingBottom: height.value > insets?.bottom
            ? isTabOrDesktopDevice
                ? insets?.bottom
                : 0
            : isTabOrDesktopDevice
                ? 40
                : insets?.bottom,
    }), [
        deviceHeight,
        keyboardStatus,
        isTabOrDesktopDevice,
        height,
        isPortrait,
        isRecording,
        deviceWidth,
        mainWidth,
    ]);
    const setMessageFocus = (0, react_1.useCallback)(() => {
        setAutoFocus(true);
        setTimeout(() => {
            inputEl?.current?.focus();
        }, 100);
    }, []);
    const onPressInAction = (0, react_1.useCallback)(async () => {
        setTypingMode('voice');
        setIsRecording(true);
    }, [characterProfile]);
    const adjustInputSize = (0, react_1.useCallback)(() => {
        const inputElement = inputEl.current;
        if (inputElement) {
            inputElement.style.height = "0";
            const newSize = (inputElement.offsetHeight - inputElement.clientHeight + inputElement.scrollHeight);
            inputElement.style.height = `${newSize}px`;
        }
    }, []);
    const sendNewMessage = (0, react_1.useCallback)(async () => {
        if (conversation?.id) {
            await dispatch((0, user_2.setChatAction)(""));
            const trimMsg = newMessege.trim();
            setNewMessege('');
            inputEl.current?.focus();
            setTimeout(() => {
                adjustInputSize();
            });
            if (trimMsg?.length != 0) {
                setUploadedSources([]);
                await request(sendMessageAsStream, {
                    message: trimMsg,
                    files: uploadedSources.map((source) => ({ file: source.file, url: source.url })),
                }, selectedFileIds, null, async () => {
                    // @todo : flash experience for user, fix it
                    // setLatestMessage(newMsg);
                    dispatch((0, user_2.setCharacterIsTyping)(false));
                    setTypingMode("");
                    timerRef?.current && clearTimeout(timerRef.current);
                    if (constants_1.AUTOPLAY_MESSAGE_SPEECH && voiceAutoPlay) {
                        dispatch((0, user_2.setStartVoiceAutoPlay)(true));
                    }
                    ;
                });
            }
            ;
        }
        ;
    }, [
        conversation,
        newMessege,
        uploadedSources,
        selectedFileIds,
        keyboardStatus,
        fbUser,
        sendMessageAsStream,
        request,
    ]);
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => (() => {
        wasDocumentClearedControl.current = false;
        wasConversationStarted.current = false;
    }), []));
    (0, native_1.useFocusEffect)(react_1.default.useCallback(() => {
        if (react_native_1.Platform.OS !== "web") {
            const onBackPress = () => {
                if (isFocused) {
                    console.log("Back pressed.!");
                    (0, rootNavigation_1.navigate)(constants_1.DISCOVER_MODE ? "Chats" : "AllCharacterList");
                    return true;
                }
                else {
                    return false;
                }
            };
            react_native_1.BackHandler.addEventListener("hardwareBackPress", onBackPress);
            return () => react_native_1.BackHandler.removeEventListener("hardwareBackPress", onBackPress);
        }
    }, [rootNavigation_1.navigate, isFocused]));
    (0, react_1.useEffect)(() => {
        if (isFocused) {
            if (!isTabOrDesktopDevice && navigation) {
                const { routes } = navigation?.getState();
                if (routes) {
                    const screenCounts = routes?.filter((route) => route.name === "OneToOneChat")?.length;
                    // reset screens if more then one screens
                    if (screenCounts > 1) {
                        navigation.reset({
                            index: 1,
                            routes: [{ name: "Home", params: { screen: { name: "Chats" } } }],
                        });
                    }
                    ;
                }
                ;
            }
            ;
        }
        ;
    }, [isFocused]);
    (0, react_1.useEffect)(() => {
        if (messageQuota?.consumed === messageQuota?.quota || isRecording) {
            react_native_1.Keyboard.dismiss();
        }
    }, [messageQuota, isRecording]);
    (0, react_1.useEffect)(() => {
        if (react_native_1.Platform.OS !== "web") {
            const showKeySubscription = react_native_1.Keyboard.addListener("keyboardDidShow", () => {
                console.log("keyboardDidShow");
                boxHeight.value = 100;
                setKeyboardStatus("Keyboard_Shown");
            });
            const showSubscription = react_native_1.Keyboard.addListener("keyboardWillShow", () => {
                console.log("keyboardWillShow");
                setKeyboardStatus("Keyboard_Shown");
                setTypingMode("text");
                boxHeight.value = 100;
            });
            const hideKeySubscription = react_native_1.Keyboard.addListener("keyboardWillHide", () => {
                setKeyboardStatus("Keyboard_Hidden");
                boxHeight.value = height.value;
                console.log("keyboardWillHide");
                setTypingMode("");
            });
            const hideSubscription = react_native_1.Keyboard.addListener("keyboardDidHide", () => {
                console.log("keyboardDidHide");
                boxHeight.value = height.value;
                setKeyboardStatus("Keyboard_Hidden");
            });
            setNewMessege("");
            return () => {
                showSubscription.remove();
                hideSubscription.remove();
                hideKeySubscription.remove();
                showKeySubscription.remove();
            };
        }
        else {
            setNewMessege("");
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (isFocused) {
            console.log("focused reset typing mode....");
            setTypingMode("");
        }
    }, [isFocused]);
    (0, react_1.useEffect)(() => {
        // Keyboard status got toggled to shown
        if (keyboardStatus === "Keyboard_Shown" && typingMode !== "text") {
            console.log("reset typing mode forcefully....!");
            setTypingMode("text");
        }
    }, [keyboardStatus, typingMode]);
    (0, react_1.useEffect)(() => {
        let wasUnmounted = false;
        if (characterId !== oldCharacterId
            && characterProfile.id.toString() !== characterId
            && !paramConversationId
            && !paramShareId) {
            const getCharacter = async () => {
                pickConversation(characterId);
            };
            if (characterId && user?.id) {
                setOldCharacterId(characterId);
                getCharacter();
            }
            ;
        }
        ;
        return () => { wasUnmounted = true; };
    }, [
        user,
        characterProfile,
        isWebDevice,
        isMobileScreen,
        characterId,
        pickConversation,
    ]);
    (0, react_1.useEffect)(() => {
        if (paramConversationId && isFocused) {
            let wasUnmounted = false;
            const fetchSummary = async (conversationId) => {
                request(document_3.getSummary, conversationId).then((document) => {
                    if (!wasUnmounted && document) {
                        dispatch((0, document_2.setDocumentJson)(document));
                        pickConversation(document.character_id);
                    }
                    ;
                });
            };
            if (user && paramConversationId && !wasDocumentFetchedControl.current && isFocused) {
                if (!documentJson) {
                    fetchSummary(paramConversationId);
                }
                else if (documentJson.conversationId !== conversation?.id) {
                    pickConversation(documentJson.character_id);
                }
                wasDocumentFetchedControl.current = true;
            }
            ;
            return () => { wasUnmounted = true; };
        }
    }, [
        paramConversationId,
        user,
        conversation,
        isFocused,
        pickConversation,
        request,
    ]);
    (0, react_1.useEffect)(() => {
        let wasUnmounted = false;
        const fetchSharedSummary = (shareId, password) => {
            request(document_3.getSharedSummary, shareId, password).then(async (sharedDocument) => {
                if (!wasUnmounted && sharedDocument) {
                    dispatch((0, document_2.setDocumentJson)(sharedDocument));
                }
                ;
            });
        };
        if (user && paramShareId && !wasDocumentFetchedControl.current && !documentJson && isFocused) {
            fetchSharedSummary(paramShareId, password);
            wasDocumentFetchedControl.current = true;
        }
        ;
        return () => { wasUnmounted = true; };
    }, [
        user,
        conversation,
        paramShareId,
        password,
        isFocused,
        request,
    ]);
    (0, react_1.useEffect)(() => {
        if (autoMessage) {
            dispatch((0, user_2.setAutoSentMessage)(autoMessage));
        }
        ;
    }, [autoMessage, dispatch]);
    (0, react_1.useEffect)(() => {
        if (!uploadedSources.length) {
            setSourcesHeight(0);
        }
    }, [uploadedSources]);
    const handleUploadImages = (0, react_1.useCallback)((files) => {
        setUploadedSources((previousImages) => [
            ...previousImages,
            ...files.map((file) => ({ file, url: URL.createObjectURL(file), type: 'image' }))
        ]);
    }, []);
    const handleUploadFiles = (0, react_1.useCallback)((files) => {
        setUploadedSources((previousImages) => [
            ...previousImages,
            ...files.map((file) => ({
                file,
                url: URL.createObjectURL(file),
                name: file.name,
                type: 'file',
            }))
        ]);
    }, []);
    const handleRemoveSource = (0, react_1.useCallback)((url) => {
        setUploadedSources((previousImages) => previousImages.filter((previousImage) => (previousImage.url !== url)));
    }, []);
    const handleSourcesLayout = (0, react_1.useCallback)((event) => {
        setSourcesHeight(event.nativeEvent.layout.height);
    }, []);
    const handleKeyDown = (0, react_1.useCallback)(async (event) => {
        const { nativeEvent } = event;
        if (nativeEvent.key) {
            if (nativeEvent.key === "Enter" &&
                !nativeEvent.shiftKey &&
                textStreaming === "" &&
                isDesktopDevice) {
                event.preventDefault();
                sendNewMessage();
            }
        }
    }, [textStreaming, isDesktopDevice, sendNewMessage]);
    const handleSpeechText = (0, react_1.useCallback)((speechText) => {
        setNewMessege(speechText);
    }, []);
    const handleSuggessionPill = (0, react_1.useCallback)(async (autoMessage) => {
        react_native_1.Keyboard.dismiss();
        await setNewMessege(autoMessage);
        sendNewMessage();
    }, [sendNewMessage]);
    const handleMembershipAction = (0, react_1.useCallback)(async () => {
        if (isUserLogged) {
            react_native_1.Linking.openURL('mailto:info@makr.ai?subject=How\'s%20your%20experience%20so%20far?');
        }
        else {
            (0, rootNavigation_1.navigate)('LoginPage');
        }
    }, [isUserLogged, navigation]);
    const handleTextChange = (0, react_1.useCallback)((newMsg) => {
        setNewMessege(newMsg);
        if (isWebDevice) {
            adjustInputSize();
        }
    }, [adjustInputSize, isWebDevice]);
    if ((paramConversationId && paramConversationId !== conversation?.id
        || (paramShareId
            && documentJson
            && 'shareId' in documentJson
            && paramShareId !== documentJson.shareId)) && !wasDocumentClearedControl.current && isFocused) {
        dispatch((0, user_2.resetCharacter)());
        dispatch((0, user_2.clearDocument)());
        wasDocumentClearedControl.current = true;
        wasDocumentFetchedControl.current = false;
    }
    ;
    if (paramShareId
        && documentJson
        && 'shareId' in documentJson
        && paramShareId === documentJson.shareId
        && (documentJson.sharedBy !== user?.id || documentJson.conversationId !== conversation?.id) && !wasConversationStarted.current
        && isFocused) {
        dispatch((0, user_2.resetCharacter)());
        startDocumentConversation({ shareId: paramShareId });
        wasConversationStarted.current = true;
    }
    return ((0, jsx_runtime_1.jsxs)(AppBackground_1.default, { children: [(0, jsx_runtime_1.jsx)(AppLoader_1.default, { showLoader: isWebDevice, isLoading: !wasCharacterLoaded }), isFocused && (wasCharacterLoaded || !isWebDevice) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isTabOrDesktopDevice && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            paddingTop: 14,
                            paddingLeft: 12,
                            paddingBottom: 6,
                            paddingRight: 16,
                            borderColor: colors_1.Colors.DARK_600,
                            borderBottomWidth: 1,
                        }, children: [conversation && ((0, jsx_runtime_1.jsx)(DocumentHeaderItem_1.default, { character: characterProfile, onPress: () => {
                                    (0, rootNavigation_1.navigate)('Summary', { conversationId: conversation.id });
                                } })), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                    gap: 24,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                }, children: [(0, jsx_runtime_1.jsx)(ChatThreadsHeaderButton_1.default, { menuVerticalOffset: 12, menuHorizontalOffset: 124 }), conversation && documentJson && ((0, jsx_runtime_1.jsx)(AppButton_1.ShareButton, { onPress: () => {
                                            showShareLink(documentJson);
                                        }, style: {
                                            marginBottom: 5,
                                        } }))] })] })), !isTabOrDesktopDevice && isMsgBox && !isWebDevice && (0, jsx_runtime_1.jsx)(AppQuotaAlert_1.default, {}), conversation?.participantId === characterProfile.id.toString() && ((0, jsx_runtime_1.jsx)(ChatMessages_1.default, { conversation: conversation })), messageQuota?.consumed === messageQuota?.quota &&
                        messageQuota?.quota && ((0, jsx_runtime_1.jsx)(UpgradeBanner_1.default, {})), isMsgBox && !wasReachedMessagesLimit && ((0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureHandlerRootView, { style: { flexShrink: 0, flexBasis: 'auto' }, children: (0, jsx_runtime_1.jsx)(AnimatedContainer, { bg: isRecording && keyboardStatus === "Keyboard_Shown"
                                ? colors_1.Colors.PRIMARY_700
                                : "#292a2f", style: containerStyle, children: (0, jsx_runtime_1.jsx)(native_base_1.HStack, { space: 3, width: "100%", children: (0, jsx_runtime_1.jsxs)(VStack_1.default, { width: "100%", space: 2.5, children: [(0, jsx_runtime_1.jsx)(UploadedSources_1.default, { sources: uploadedSources, onLayout: handleSourcesLayout, onCloseSource: handleRemoveSource }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                                width: isWebDevice && isMobileScreen ? '100%' : deviceWidth - 20,
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                paddingVertical: react_native_1.Platform.OS === 'web' ? 2.5 : 1,
                                                paddingHorizontal: 16,
                                                paddingTop: isWebDevice && isMobileScreen ? 1.5 : undefined,
                                                backgroundColor: colors_1.Colors.DARK_600,
                                                maxWidth: react_native_1.Platform.OS === "web" ? "100%" : deviceWidth,
                                                alignSelf: "center",
                                                gap: 12
                                            }, children: [(0, jsx_runtime_1.jsx)(UploadMenu_1.default, { verticalOffset: sourcesHeight && (sourcesHeight + 2.5 * 4), handleUploadImages: handleUploadImages, handleUploadFiles: handleUploadFiles, options: {
                                                        images: !wasUploadedFile,
                                                        files: !wasUploadedImage
                                                    } }), (0, jsx_runtime_1.jsx)(ScrollCustomIndicator_1.default, { pointerEvents: "box-none", disableScrollViewPanResponder: true, scrollEnabled: isWebDevice && !isMobileScreen, style: {
                                                        maxHeight: isWebDevice && !isMobileScreen ? 136 : undefined,
                                                    }, containerStyle: {
                                                        flex: 1,
                                                    }, customIndicator: isWebDevice && !isMobileScreen, indicatorOverlay: true, children: (0, jsx_runtime_1.jsx)(MesssageBoxInput_1.default, { inputRef: (innerRef) => (inputEl.current = innerRef), placeholder: `Message...`, placeholderTextColor: colors_1.Colors.DARK_THEME_PLACEHOLDER, keyboardAppearance: "dark", width: "100%", minHeight: react_native_1.Platform.OS === 'web' ? 44 : undefined, maxHeight: isMobileScreen ? 142 : undefined, maxWidth: react_native_1.Platform.OS === "web"
                                                            ? "100%"
                                                            : deviceWidth -
                                                                (X_INSETS + MESSAGE_BUTTON_WIDTH + 10), handlePress: () => {
                                                            // setNewMessege((newMsg)=>);
                                                            console.log("Doing it.!");
                                                            // setNewMessege((newMsg) => `${newMsg}\n`);
                                                        }, returnKeyType: "none", autoFocus: autoFocus, 
                                                        // value={newMessege}
                                                        // width={"88%"}
                                                        borderRadius: 8, borderColor: isWebDevice && isMobileScreen ? colors_1.Colors.DARK_500 : undefined, fontSize: (0, theme_1.normalize)(16), numberOfLines: react_native_1.Platform.OS === 'web' ? 1 : 5, multiline: true, editable: !(characterIsTyping || isImageLoading), borderWidth: react_native_1.Platform.OS === "ios"
                                                            ? 0.1
                                                            : isWebDevice && isMobileScreen
                                                                ? 0.5
                                                                : 0, padding: react_native_1.Platform.OS === "ios"
                                                            ? 3
                                                            : isWebDevice && isMobileScreen
                                                                ? 11
                                                                : 2, 
                                                        // paddingRight={isMobileScreen ? 44 : undefined}
                                                        audioMode: isRecording, 
                                                        // onPressIn={onOpen}
                                                        pointerEvents: react_native_1.Platform.OS === 'web' ? 'auto' : 'box-none', onKeyPress: handleKeyDown, 
                                                        // blurOnSubmit={true}
                                                        defaultValue: newMessege, value: newMessege, onChangeText: handleTextChange, isDisabled: (messageQuota.consumed === messageQuota?.quota
                                                            && messageQuota?.quota !== 0) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                                        position: 'absolute',
                                                        right: 20,
                                                    }, children: (typingMode !== "text" ||
                                                        newMessege.trim().length === 0) &&
                                                        !characterIsTyping &&
                                                        !(!isRecording &&
                                                            keyboardStatus === "Keyboard_Hidden" &&
                                                            newMessege.trim().length > 0) &&
                                                        (!isWebDevice || browserSupportsSpeechRecognition) ? ((0, jsx_runtime_1.jsx)(MicrophoneButton_1.MicrophoneButton, { setSpeechText: handleSpeechText, inputText: newMessege, sendMessage: sendNewMessage, isRecording: isRecording, setIsRecording: setIsRecording, typingMode: typingMode, setTypingMode: setTypingMode, timerRef: timerRef, setMessageFocus: setMessageFocus, forceVoiceStop: forceVoiceStop, setForceVoiceStop: setForceVoiceStop, setNewPitch: setPitch, onPressInAction: onPressInAction })) : ((0, jsx_runtime_1.jsx)(SendButton_1.SendButton, { onPress: () => {
                                                            sendNewMessage();
                                                        }, 
                                                        // If we don't have quota from API don't use it
                                                        disabled: (messageQuota &&
                                                            messageQuota?.consumed ===
                                                                messageQuota?.quota &&
                                                            messageQuota?.quota !== 0) ||
                                                            newMessege.trim().length === 0 ||
                                                            characterIsTyping ||
                                                            isImageLoading, style: {
                                                            marginRight: (isWebDevice && isMobileScreen) ? 12 : 10,
                                                        } })) })] }), isRecording && keyboardStatus === "Keyboard_Hidden" && ((0, jsx_runtime_1.jsxs)(react_native_reanimated_1.default.View, { style: [
                                                boxAnimation,
                                                {
                                                    backgroundColor: colors_1.Colors.PRIMARY_700,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                },
                                            ], children: [(0, jsx_runtime_1.jsx)(native_base_1.Stack, { style: { position: "absolute" }, children: (0, jsx_runtime_1.jsx)(lottie_react_native_1.default, { source: require("../../assets/icons/lottie/voice-ripples.json"), autoPlay: true, loop: true, autoSize: true, resizeMode: "cover", style: {
                                                            height: rippleSize,
                                                            width: rippleSize,
                                                        } }) }), (0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.TouchableOpacity, { onPress: () => {
                                                        setForceVoiceStop(true);
                                                    }, children: (0, jsx_runtime_1.jsxs)(native_base_1.HStack, { space: 2, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faStopCircle, color: colors_1.Colors.WHITE_SECONDARY, size: 18 }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.white, children: "Tap here to stop recording" })] }) })] }))] }) }) }) }))] }))] }));
};
exports.default = (0, react_1.memo)(OneToOneChat);
